// extracted by mini-css-extract-plugin
export default {"wrapper":"Slider_wrapper__QmXNV"};